
export default {
    table: {

    } as React.CSSProperties,
    th: {
        borderTop: "solid 1px lightgray",
        borderRight: "solid 1px lightgray",
        borderBottom: "solid 1px lightgray",
        backgroundColor: "#eee",
        padding: 5
    } as React.CSSProperties,
    thFirst: {
        borderTop: "solid 1px lightgray",
        borderLeft: "solid 1px lightgray",
        borderRight: "solid 1px lightgray",
        borderBottom: "solid 1px lightgray",
        backgroundColor: "#eee",
        padding: 5
    } as React.CSSProperties,
    td: {
        borderRight: "solid 1px lightgray",
        borderBottom: "solid 1px lightgray",
        backgroundColor: "white",
        padding: 5
    } as React.CSSProperties,
    tdFirst: {
        borderLeft: "solid 1px lightgray",
        borderRight: "solid 1px lightgray",
        borderBottom: "solid 1px lightgray",
        backgroundColor: "white",
        padding: 5
    } as React.CSSProperties,
    highlight: {
        color:"black",
        backgroundColor:"#99CCFF",
    } as React.CSSProperties,
    highlightDanger: {
        color:"black",
        backgroundColor:"#EFCECE",
    } as React.CSSProperties,
    highlightWarning: {
        color:"black",
        backgroundColor:"#FFA64D",
    } as React.CSSProperties,
};
 
